import React from 'react';
import { COLORS, FlexView, toRGBA } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

import { STOverallInfoContainer } from '../student-transfer/styles/overall-info';

const TransferTeacherInfo = () => {
  return (
    <STOverallInfoContainer>
      <FlexView>
        <Text variant="body1Medium">-</Text>
        <Text variant="body2" color={toRGBA(COLORS.COLA, 0.75)}>
          -
        </Text>
      </FlexView>
    </STOverallInfoContainer>
  );
};

export default TransferTeacherInfo;
